import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Factsheet: {
    id: 'key_data_factsheet',
    defaultMessage: 'Factsheet',
  },
  KeyData: {
    id: 'key_data_title',
    defaultMessage: 'Key data',
  },
  ProjectDetails: {
    id: 'key_data_project_details',
    defaultMessage: 'Project details',
  },
  USPsTitle: {
    id: 'key_data_usps_title',
    defaultMessage: 'At a glance',
  },
  Degree: {
    id: 'key_data_degree',
    defaultMessage: 'Degree',
  },
  StudyMode: {
    id: 'key_data_studymode',
    defaultMessage: 'Study mode',
  },
  LearningEnvironment: {
    id: 'key_data_learningenvironment',
    defaultMessage: 'Learning mode',
  },
  ECTSPoints: {
    id: 'key_data_ectspoint',
    defaultMessage: 'ECTS credits',
  },
  NextStart: {
    id: 'key_data_nextstart',
    defaultMessage: 'Next start',
  },
  Duration: {
    id: 'key_data_duration',
    defaultMessage: 'Duration',
  },
  Language: {
    id: 'key_data_language',
    defaultMessage: 'Teaching language',
  },
  Place: {
    id: 'key_data_place',
    defaultMessage: 'Place',
  },
  StayingAbroad: {
    id: 'key_data_stayingabroad',
    defaultMessage: 'Stay abroad',
  },
  ApplicationFee: {
    id: 'key_data_applicationfee',
    defaultMessage: 'Application fee',
  },
  SemesterFee: {
    id: 'key_data_semesterfee',
    defaultMessage: 'Semester fee',
  },
  Documents: {
    id: 'key_data_documents',
    defaultMessage: 'Documents',
  },
  GTC: {
    id: 'key_data_gtc',
    defaultMessage: 'General terms and conditions',
  },
  ToGTC: {
    id: 'key_data_togtc',
    defaultMessage: 'To the general terms and conditions',
  },
  TeachingLanguages: {
    id: 'key_data_teachinglanguages',
    defaultMessage: 'Teaching language',
  },
  Venues: {
    id: 'key_data_venues',
    defaultMessage: 'Place',
  },
  Fee: {
    id: 'key_data_fee',
    defaultMessage: 'Fee',
  },
  AdmissionRequirements: {
    id: 'key_data_admissionrequirements',
    defaultMessage: 'Admission requirements',
  },
  FinancingTerms: {
    id: 'key_data_financingterms',
    defaultMessage: 'Financing terms',
  },
  EducationFormat: {
    id: 'key_data_educationformat',
    defaultMessage: 'Education format',
  },
  TargetAudience: {
    id: 'key_data_targetaudience',
    defaultMessage: 'Target audience',
  },
  CostAbsorption: {
    id: 'key_data_costabsorption',
    defaultMessage: 'Cost absorption',
  },
  Type: {
    id: 'key_data_type',
    defaultMessage: 'Type',
  },
  ResearchAreas: {
    id: 'key_data_researchareas',
    defaultMessage: 'Research field',
  },
  Topics: {
    id: 'key_data_topics',
    defaultMessage: 'Topics',
  },
  University: {
    id: 'key_data_university',
    defaultMessage: 'School',
  },
  Partner: {
    id: 'key_data_partner',
    defaultMessage: 'Partners',
  },
  Funding: {
    id: 'key_data_funding',
    defaultMessage: 'Funding',
  },
  Volume: {
    id: 'key_data_volume',
    defaultMessage: 'Project budget',
  },
  RunningTime: {
    id: 'key_data_runningtime',
    defaultMessage: 'Duration',
  },
  Management: {
    id: 'key_data_management',
    defaultMessage: 'Project lead',
  },
  Collaboration: {
    id: 'key_data_collaboration',
    defaultMessage: 'Team',
  },
  OrganizedBy: {
    id: 'key_data_organizedby',
    defaultMessage: 'Organized by',
  },
  EventLanguage: {
    id: 'key_data_eventlanguage',
    defaultMessage: 'Event language',
  },
  Expenses: {
    id: 'key_data_expenses',
    defaultMessage: 'Expenses',
  },
  Address: {
    id: 'key_data_address',
    defaultMessage: 'Address',
  },
  Occasions: {
    id: 'key_data_occasions',
    defaultMessage: 'Occasions',
  },
  RollingIntake: {
    id: 'key_data_rolling_intake',
    defaultMessage: 'Rolling intake possible',
  },
  ProductCode: {
    id: 'key_data_product_code',
    defaultMessage: 'Number',
  },
});
